import { Button } from "@/components/ui/button";
import { Database, Upload } from "lucide-react";

interface ActionButtonsProps {
  onImportData: () => void;
  onGenerateSchema: () => void;
  isProcessing: boolean;
  importEnabled: boolean;
  actionsEnabled: boolean;
  hasQualityIssues: boolean;
  schemaEnabled: boolean;
  schemaGenerated: boolean;
}

export const ActionButtons = ({
  onImportData,
  onGenerateSchema,
  isProcessing,
  importEnabled,
  actionsEnabled,
  hasQualityIssues,
  schemaEnabled,
  schemaGenerated,
}: ActionButtonsProps) => {
  return (
    <div className="grid grid-cols-2 gap-2 w-full">
      <Button
        onClick={onImportData}
        disabled={!importEnabled || isProcessing}
        variant={importEnabled && schemaGenerated ? "success" : "default"}
      >
        <Upload className="mr-2 h-4 w-4" />
        Import Data
      </Button>
      <Button
        onClick={onGenerateSchema}
        disabled={!schemaEnabled || isProcessing}
        className="w-full bg-[#1B3668] hover:bg-[#1B3668]/90 text-white"
      >
        <Database className="mr-2 h-4 w-4" />
        Generate Schema
      </Button>
    </div>
  );
};